import React from 'react';
import type { SVGProps } from 'react';

export const SwapIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg width='16' height='16' viewBox='0 0 13.0667 15.7333' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.48954 0.15621C9.69782 -0.0520699 10.0355 -0.0520699 10.2438 0.15621L12.9105 2.82288C13.1187 3.03116 13.1187 3.36884 12.9105 3.57712L10.2438 6.24379C10.0355 6.45207 9.69782 6.45207 9.48954 6.24379C9.28126 6.03551 9.28126 5.69782 9.48954 5.48954L11.7791 3.2L9.48954 0.910457C9.28126 0.702177 9.28126 0.364489 9.48954 0.15621Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.2 3.73333C2.6342 3.73333 2.09158 3.95809 1.69151 4.35817C1.29143 4.75825 1.06667 5.30087 1.06667 5.86667V7.2C1.06667 7.49455 0.827885 7.73333 0.533333 7.73333C0.238781 7.73333 0 7.49455 0 7.2V5.86667C0 5.01797 0.337142 4.20404 0.937258 3.60392C1.53737 3.00381 2.35131 2.66667 3.2 2.66667H12.5333C12.8279 2.66667 13.0667 2.90545 13.0667 3.2C13.0667 3.49455 12.8279 3.73333 12.5333 3.73333H3.2Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.57712 9.48954C3.7854 9.69782 3.7854 10.0355 3.57712 10.2438L1.28758 12.5333L3.57712 14.8229C3.7854 15.0312 3.7854 15.3688 3.57712 15.5771C3.36884 15.7854 3.03116 15.7854 2.82288 15.5771L0.15621 12.9105C-0.0520699 12.7022 -0.0520699 12.3645 0.15621 12.1562L2.82288 9.48954C3.03116 9.28126 3.36884 9.28126 3.57712 9.48954Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.5333 8C12.8279 8 13.0667 8.23878 13.0667 8.53333V9.86667C13.0667 10.7154 12.7295 11.5293 12.1294 12.1294C11.5293 12.7295 10.7154 13.0667 9.86667 13.0667H0.533333C0.238781 13.0667 0 12.8279 0 12.5333C0 12.2388 0.238781 12 0.533333 12H9.86667C10.4325 12 10.9751 11.7752 11.3752 11.3752C11.7752 10.9751 12 10.4325 12 9.86667V8.53333C12 8.23878 12.2388 8 12.5333 8Z'
      fill='currentColor'
    />
  </svg>
);
